
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.6 0C2.96 0 0 2.924 0 6.519c0 4.46 5.906 11.01 6.158 11.286a.6.6 0 00.884 0C7.294 17.53 13.2 10.98 13.2 6.52 13.2 2.924 10.24 0 6.6 0zm0 9.799c-1.831 0-3.32-1.472-3.32-3.28 0-1.809 1.489-3.28 3.32-3.28 1.831 0 3.32 1.471 3.32 3.28 0 1.808-1.489 3.28-3.32 3.28z","fill":"currentColor","fill-rule":"nonzero"}})])
          )
        }
      }
    